module.exports = __webpack_public_path__ + "static/media/lb_01 (1).9018969c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lb_01 (1).jpg
// module id = 2004
// module chunks = 2